module.exports = __webpack_public_path__ + "img/score_6.ef80a580.png";